import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import { Brand, brandResource } from "@megarax/client/src/resources/plm";

export const brandModule: ResourceAppModule = {
  app: plmApp,
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  iconClass: "fas fa-registered fa-fw",
  title: "Marki handlowe",
  route: "markaHandlowa",
  itemConstructor: Brand,
  resource: brandResource,
};
